import { useSyncExternalStore } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { confirmStore } from '@/lib/dialog';

/** Renders the one pending `confirmDialog()` request. Mount once, at the root. */
export function ConfirmHost() {
  const req = useSyncExternalStore(confirmStore.subscribe, confirmStore.get, confirmStore.get);
  return (
    <Dialog open={req != null} onOpenChange={(open) => !open && confirmStore.settle(false)}>
      <DialogContent data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle>{req?.title ?? 'Are you sure?'}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">{req?.message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" autoFocus={!!req?.destructive} onClick={() => confirmStore.settle(false)}>
            {req?.cancelLabel ?? 'Cancel'}
          </Button>
          <Button
            variant={req?.destructive ? 'destructive' : 'default'}
            autoFocus={!req?.destructive}
            onClick={() => confirmStore.settle(true)}
          >
            {req?.confirmLabel ?? 'OK'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
